import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { countReviewVentureStatuses, formatReviewTypeLabel, isReviewRequestFullyApproved, usePortfolioReviewContext } from '~/functions/review';
import { ReviewType, useGetUserQuery, useListReviewRequestsQuery } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var reviewTypeText = function reviewTypeText(reviewType) {
      return formatReviewTypeLabel(reviewType, proxy.$t.bind(proxy));
    };
    var _usePortfolioReviewCo = usePortfolioReviewContext(),
      hasReviewerRole = _usePortfolioReviewCo.hasReviewerRole,
      account = _usePortfolioReviewCo.account,
      isEditor = _usePortfolioReviewCo.isEditor;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var isIxAdminSession = computed(function () {
      var _user$value, _user$value2;
      return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) && !((_user$value2 = user.value) !== null && _user$value2 !== void 0 && _user$value2.isImpersonated);
    });
    var canCreateReview = computed(function () {
      return isIxAdminSession.value || isEditor.value;
    });
    var router = useRouter();
    var search = ref('');
    var showDeleteDialog = ref(false);
    var selectedReviewId = ref(null);
    var showDebugging = useShowDebugging();
    var _useListReviewRequest = useListReviewRequestsQuery(computed(function () {
        return {
          enabled: hasReviewerRole.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useListReviewRequest.result,
      loading = _useListReviewRequest.loading,
      refetch = _useListReviewRequest.refetch;
    onActivated(function () {
      if (hasReviewerRole.value) {
        refetch();
      }
    });
    var requests = computed(function () {
      var _result$value$listRev, _result$value;
      return (_result$value$listRev = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listReviewRequests) !== null && _result$value$listRev !== void 0 ? _result$value$listRev : [];
    });
    var showActionsColumn = computed(function () {
      return showDebugging.value;
    });
    var filteredRequests = computed(function () {
      var q = search.value.trim().toLowerCase();
      if (!q) {
        return requests.value;
      }
      var reviewTypeText = formatReviewTypeLabel(ReviewType.TheoryOfChange, proxy.$t.bind(proxy)).toLowerCase();
      return requests.value.filter(function (r) {
        var _r$title, _r$createdBy, _r$createdBy$email;
        return ((_r$title = r.title) === null || _r$title === void 0 ? void 0 : _r$title.toLowerCase().includes(q)) || ((_r$createdBy = r.createdBy) === null || _r$createdBy === void 0 ? void 0 : (_r$createdBy$email = _r$createdBy.email) === null || _r$createdBy$email === void 0 ? void 0 : _r$createdBy$email.toLowerCase().includes(q)) || reviewTypeText.includes(q);
      });
    });
    var headers = computed(function () {
      var baseHeaders = [{
        text: proxy.$t('headerCreated'),
        value: 'createdAt',
        class: 'review-table-th',
        width: '152px'
      }, {
        text: proxy.$t('headerReviewType'),
        value: 'reviewType',
        class: 'review-table-th',
        width: '210px'
      }, {
        text: proxy.$t('headerTitle'),
        value: 'title',
        class: 'review-table-th'
      }, {
        text: proxy.$t('headerCreatedBy'),
        value: 'createdBy',
        class: 'review-table-th',
        width: '190px'
      }, {
        text: proxy.$t('headerAssignedTo'),
        value: 'assignedTo',
        class: 'review-table-th',
        sortable: false,
        width: '190px'
      }, {
        text: proxy.$t('headerCompanies'),
        value: 'companies',
        class: 'review-table-th',
        sortable: false,
        width: '240px'
      }, {
        text: proxy.$t('headerStatus'),
        value: 'status',
        class: 'review-table-th',
        sortable: false,
        width: '210px'
      }];
      if (showActionsColumn.value) {
        baseHeaders.push({
          text: proxy.$t('headerActions'),
          value: 'actions',
          sortable: false,
          align: 'end',
          class: 'review-table-th',
          width: '84px'
        });
      }
      return baseHeaders;
    });
    var statusCounts = function statusCounts(item) {
      return countReviewVentureStatuses(item.ventures);
    };
    var statusChipStatus = function statusChipStatus(item) {
      return isReviewRequestFullyApproved(item.ventures) ? 'APPROVED' : 'IN_PROGRESS';
    };
    var statusChipLabel = function statusChipLabel(item) {
      var counts = statusCounts(item);
      if (isReviewRequestFullyApproved(item.ventures)) {
        return String(proxy.$t('statusComplete'));
      }
      if (counts.APPROVED > 0 || counts.EDITS_REQUESTED > 0) {
        return String(proxy.$t('statusInProgress'));
      }
      return String(proxy.$t('statusIncomplete'));
    };
    var companyApprovalRows = function companyApprovalRows(item) {
      var _item$ventures;
      return ((_item$ventures = item.ventures) !== null && _item$ventures !== void 0 ? _item$ventures : []).map(function (venture) {
        var _venture$venture, _venture$venture2;
        return {
          id: venture.ventureId || ((_venture$venture = venture.venture) === null || _venture$venture === void 0 ? void 0 : _venture$venture.name) || 'unknown',
          name: ((_venture$venture2 = venture.venture) === null || _venture$venture2 === void 0 ? void 0 : _venture$venture2.name) || venture.ventureId || '—',
          status: venture.status || 'AWAITING_REVIEW'
        };
      });
    };
    var companyStatusLabel = function companyStatusLabel(status) {
      switch (status) {
        case 'APPROVED':
          return String(proxy.$t('statusApproved'));
        case 'EDITS_REQUESTED':
          return String(proxy.$t('statusEdits'));
        default:
          return String(proxy.$t('statusAwaiting'));
      }
    };
    var isAssignedToAllReviewers = function isAssignedToAllReviewers(item) {
      var _item$assignedReviewe;
      return !((_item$assignedReviewe = item.assignedReviewers) !== null && _item$assignedReviewe !== void 0 && _item$assignedReviewe.length);
    };
    var formatDate = function formatDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleString();
    };
    var goToRequest = function goToRequest(_event, _ref2) {
      var item = _ref2.item;
      router.push("/portfolio/review/".concat(item.id));
    };
    var openDeleteDialog = function openDeleteDialog(reviewId) {
      selectedReviewId.value = reviewId;
      showDeleteDialog.value = true;
    };
    var onDeleteDialogInput = function onDeleteDialogInput(open) {
      showDeleteDialog.value = open;
      if (!open) {
        selectedReviewId.value = null;
      }
    };
    return {
      __sfc: true,
      proxy: proxy,
      reviewTypeText: reviewTypeText,
      hasReviewerRole: hasReviewerRole,
      account: account,
      isEditor: isEditor,
      userResult: userResult,
      user: user,
      isIxAdminSession: isIxAdminSession,
      canCreateReview: canCreateReview,
      router: router,
      search: search,
      showDeleteDialog: showDeleteDialog,
      selectedReviewId: selectedReviewId,
      showDebugging: showDebugging,
      result: result,
      loading: loading,
      refetch: refetch,
      requests: requests,
      showActionsColumn: showActionsColumn,
      filteredRequests: filteredRequests,
      headers: headers,
      statusCounts: statusCounts,
      statusChipStatus: statusChipStatus,
      statusChipLabel: statusChipLabel,
      companyApprovalRows: companyApprovalRows,
      companyStatusLabel: companyStatusLabel,
      isAssignedToAllReviewers: isAssignedToAllReviewers,
      formatDate: formatDate,
      goToRequest: goToRequest,
      openDeleteDialog: openDeleteDialog,
      onDeleteDialogInput: onDeleteDialogInput
    };
  }
});